import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './hint-flag-item.styles';
import { Label } from 'core/components/label';
import InfoIcon from 'core/assets/svg/info-gray.svg';

const HintFlagItem = ({ message }) => {
  const classes = useStyles();

  return (
    <div className={classes.flagContainer}>
      <div className={classes.triangle} />
      <div className={classes.flagContent}>
        <div className={classes.hintHeader}>
          <img src={InfoIcon} className={classes.hintIcon} />
          <Label type="infoSubtitle" className={classes.hintTitle}>
            HINT
          </Label>
        </div>
        <Label type="body1Bold" className={classes.flagMessage}>
          {message}
        </Label>
      </div>
    </div>
  );
};

HintFlagItem.propTypes = {
  message: PropTypes.string.isRequired
};

export default HintFlagItem;
